import { render, staticRenderFns } from "./SectionDiscipline.vue?vue&type=template&id=2c867007&scoped=true"
import script from "./SectionDiscipline.vue?vue&type=script&lang=js"
export * from "./SectionDiscipline.vue?vue&type=script&lang=js"
import style0 from "./SectionDiscipline.vue?vue&type=style&index=0&id=2c867007&prod&lang=css"
import style1 from "./SectionDiscipline.vue?vue&type=style&index=1&id=2c867007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c867007",
  null
  
)

export default component.exports